import WorthyApi from 'lib/api/worthyApi';
import rootStore from 'reducers';
import {hideLoader, showLoader} from 'actions/loader';

export const NEW_JB = Symbol('NEW_JB');

export function createJewelryBox(params) {
    rootStore.dispatch(showLoader(false));

    let request = WorthyApi.createJewelryBox(params).then((response) => {
        rootStore.dispatch(hideLoader(false));
        return response;
    }).catch((error)=>{
        rootStore.dispatch(hideLoader(false));
        throw error;
    });

    return {
        type: NEW_JB,
        payload: request
    }
}